import CollectionMethod from "./CollectionMethod";

export default CollectionMethod;
